import { FC } from 'react'

import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { SecondText } from '../../style'
import { ReviewAllCheckDebitsForPaymentsWasThereProps } from './ReviewAllCheckDebitsForPaymentsWasThereProps'

export const ReviewAllCheckDebitsForPaymentsWasThere: FC<ReviewAllCheckDebitsForPaymentsWasThereProps> = ({
  Field
}) => (
  <>
    <FormRow>
      <Col2x>
        <SecondText>Review all check debits for out-of-state or unknown merchant/vendor activity.</SecondText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewAllCheckDebitsForPaymentsWasThere"
          label="Were there out-of-state check debits or unknown merchant/vendor activity?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Yes – See comments',
                value: 'yes'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions'
              },
              {
                label: 'No Transactions of This Type',
                value: 'no_transactions'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewAllCheckDebitsForPaymentsIfNoted"
          label="If noted, how was the activity addressed?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'N/A',
                value: 'n/a'
              },
              {
                label: 'Transaction cleared with communication to customer during review',
                value: 'cleared'
              },
              {
                label: 'Transaction added to annual questions',
                value: 'added'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewAllCheckDebitsForPaymentsComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
